import * as ActionTypes from '../ActionTypes';

export const GetPayrollApproverAction = (params) => {
    return {
        type: ActionTypes.PAYROLL_APPROVER_GET_REQUEST,
        params
    };
};

export const UpdatePayrollApproverAction = (params) => {
    return {
        type: ActionTypes.PAYROLL_APPROVER_UPDATE_REQUEST,
        params
    };
};

export const GetPayrollTileViewAction = (params, callback) => {
    return {
        type: ActionTypes.PAYROLL_TILE_VIEW_GET_REQUEST ,
        params,
        callback
    };
};